module.exports = __webpack_public_path__ + "img/info-person.fcf0d7c6.svg";